import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../parts/SvgIcon";

function View(props) {
  const { t } = useTranslation("common");
  return (
    <div id="error-wrapper">
      <SvgIcon
        src={"/img/new-icons/msb-logo-not-extended.svg"}
        noFilterOnLight={true}
      />
      <h1 className="alt">{t("notFound.title")}</h1>
      <p className="p2">{t("notFound.description")}</p>
      <button data-button-type="primary" onClick={() => history.back()}>
        {t("notFound.goBack")}
      </button>
    </div>
  );
}

const NotFound = (app) => {
  app.get("/404", ({ res }) => (res.body = <View />));
};

export default NotFound;
